export function parseShortDate(value: string): Date | null {
    if (!value || value === '-') return null;

    const [day, month, year] = value.split('/').map(Number);

    if (!day || !month || !year) return null;

    return new Date(year, month - 1, day);
}

export function getMonthCode(date: Date): string {
    return String(date.getMonth() + 1).padStart(2, '0');
}

export function formatDate(date: Date): string {
    return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
}

/**
 * Fecha y hora para los timestamps ISO que devuelve la API. Un valor ausente o
 * no parseable sale como '—': un guion es más honesto que "Invalid Date" o que
 * una fecha inventada.
 */
export function formatDateTime(value: string | null | undefined): string {
    if (!value) return '—';

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '—';

    const pad = (n: number) => String(n).padStart(2, '0');
    return `${formatDate(date)} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
